import { useAuth } from '../_helper/Auth/AuthProvider'

// Hook to get role-based URL prefix
export const useRoleBasedUrl = () => {
	const { user } = useAuth()

	const getRole = () => {
		switch (user?.role) {
			case 'Admin':
				return 'admin'
			case 'Instructor':
				return 'instructor'
			case 'Student911':
				return 'student911'
			case 'Student12':
				return 'student12'
			case 'Parent':
				return 'parent'
			default:
				return 'instructor'
		}
	}

	return getRole()
}
